
export default class WS {
  constructor({ token, user, setDrivers, setNewOffer, setOfferAccepted, setDeliverStatusChanged }) {
    this._token = token;
    this._me = user;

    this._connection = null;
    this._ws = null;
    this._reconnectInterval = {};
    this._drivers = [];
    this._close = false;
    this._setDrivers = setDrivers;
    this._setNewOffer = setNewOffer;
    this._setOfferAccepted = setOfferAccepted;
    this._setDeliverStatusChanged = setDeliverStatusChanged;
    this._interval = null;

    this._suggestedOrder = null;
  }

  async connect() {
    if (this._close) return;
    console.log('connecting')
    this._ws = new WebSocket(`${process.env.REACT_APP_WS_URL}/ws/location/?token=${this._token}`);
    window.ww = this._ws;

    this._ws.onopen = async () => {
      console.log('WebSocket connection established');
      if (this._reconnectInterval) {
        clearInterval(this._reconnectInterval);
        this._reconnectInterval = null;        
      }

      // this.setMyLocation();
      this._ws.send(JSON.stringify({ command: 'get_location' }));
      this._interval = window.setInterval(async () => {
        // this.setMyLocation();
        this._ws.send(JSON.stringify({ command: 'get_location' }));
      }, 10000);
    };

    this._ws.onmessage = (message) => {
      const { command, data, } = JSON.parse(message.data);
      switch (command) {
        case 'get_location':
          if (data && data.length > 0) {
            const drivers = data.filter((item) => item.role === 'DRIVER' && this._me.id !== item.id);
            this.setDrivers(drivers);
          }
          break;

        case 'suggested_order':
          break;

        case 'suggest_order':
          // if (data.driver_id === this._suggestedOrder.driver.id && data.order.uuid === this._suggestedOrder.order.uuid) {
          //   this._suggestedOrder.showMessage(`Ордер успешно предложен водителю ${this._suggestedOrder.driver.first_name} ${this._suggestedOrder.driver.first_name}`)
          // }
          break;

        case 'suggest_offer':
          // Check if the order belongs to the current user
          if (data.order && data.order.owner === this._me.id) {
            // Check if we're on my-orders page and not on offers tab
            this._setNewOffer(data);
          }
          break;

        case 'offer_accepted':
          if (data.order && data.order.owner === this._me.id) {
            // Check if we're on my-orders page and not on offers tab
            this._setOfferAccepted(data);
          }
          break;

        case 'order_delivery_status':
          if (data.order && data.order.owner === this._me.id) {
            // Check if we're on my-orders page and not on offers tab
            this._setDeliverStatusChanged(data);
          }

        
        default:
          console.log('default');    
      }
    };

    this._ws.onclose = (msg) => {
      console.log('onclose', msg);
      if (this._close) return;
      console.log('WEBSOCKET CLOSE', msg)
      console.log('WebSocket connection closed, attempting to reconnect...');
      if (!this._reconnectInterval) {
        this._reconnectInterval = setInterval(() => {
          console.log('Trying to reconnect...');
          this.connect(); // Attempt to reconnect
        }, 5000); // Retry every 5 seconds
      }
    };

    this._ws.onerror = (error) => {
      console.log('error', error);
      console.error('WebSocket error:', error);
    };
  }

  disconnect() {
    this._close = true;
    window.clearInterval(this._interval);
    this._ws.close();
  }

  setDrivers(drivers) {
    this._drivers = drivers;
    this._setDrivers(this._drivers);
  }

  getDrivers() {
    return this._drivers;
  }

  setMyLocation () {
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const data = {
          users_id: [this._me.id],
          latitude: position.coords.latitude,
          longitude: position.coords.longitude
        }
        this._ws.send(JSON.stringify({ command: 'set_location', data }))
      },
      (error) => {
        console.error("Error getting location:", error.message);
      }
    );
  }

  suggestOrder ({ driver, order, showMessage }) {
    const data = {
      driver_id: driver.id,
      order
    }

    this._suggestedOrder = {
      driver,
      order,
      showMessage
    }

    this._ws.send(JSON.stringify({ command: 'suggest_order', data }));
  }
}